export default {
  allowHeading: false,
  allowSubheading: false,
  allowButton: false
};